'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildUpdates = undefined;

var _map = require('transmute/map');

var _map2 = _interopRequireDefault(_map);

var _immutable = require('immutable');

var _Status = require('../../common-message-format/records/Status');

var _Status2 = _interopRequireDefault(_Status);

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _updateTypes = require('../constants/updateTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildUpdates = exports.buildUpdates = function buildUpdates() {
  var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var updates = (0, _immutable.fromJS)((0, _getIn2.default)(['updates'], properties));
  var updateMap = (0, _immutable.Map)();
  if (updates && updates.size) {
    (0, _map2.default)(function (update, id) {
      update.keySeq().forEach(function (updateType) {
        switch (updateType) {
          case _updateTypes.STATUS:
            updateMap = updateMap.setIn([id, _updateTypes.STATUS], (0, _Status2.default)((0, _getIn2.default)([_updateTypes.STATUS], update)));
            break;
          case _updateTypes.MESSAGE_DELETED_STATUS:
            updateMap = updateMap.setIn([id, _updateTypes.MESSAGE_DELETED_STATUS], (0, _getIn2.default)([_updateTypes.MESSAGE_DELETED_STATUS], update));
            break;
          default:
            break;
        }
      });
    }, updates);
  }

  return updateMap;
};